import { Alert } from '@interstate/components/Alert';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import { formatAsTime, formatDateTime } from '@makemydeal/dr-common-utils';
import * as pushToDmsSelectors from '@makemydeal/dr-dash-store/selectors/pushToDmsSelectors';
import { Box } from '@interstate/components/Box';

const PushToDmsSuccessBanner = () => {
    const isBaseDealer = useSelector(dealerSelectors.isBaseDealExperience);
    const lastSucceedDmsDealId = useSelector(pushToDmsSelectors.getLastSucceededDmsDealId);
    const { dealSentDate, dealSentTime } = useMemo(() => {
        const dealSentDate = formatDateTime(new Date(), 'mmddyyyy');
        const dealSentTime = formatAsTime(new Date());
        return { dealSentDate, dealSentTime };
    }, [lastSucceedDmsDealId]);
    const bannerMessage = `Deal sent to DMS on ${dealSentDate} at ${dealSentTime} with Deal ID ${lastSucceedDmsDealId}`;

    if (!lastSucceedDmsDealId) {
        return null;
    }

    return (
        <Box sx={isBaseDealer ? { padding: '1.2rem 1rem', maxWidth: '1920px', margin: 'auto' } : { marginBottom: '0.7rem' }}>
            <Alert data-testid="push-to-dms-banner-container" title={`Push to DMS`} type="success" disableSuccessFade>
                {bannerMessage}
            </Alert>
        </Box>
    );
};

export default PushToDmsSuccessBanner;
